import type { ReverseGeocodeResultItem } from "@aws-sdk/client-geo-places";
import { AWS_LOCATION_API_KEY, AWS_LOCATION_BASE_URL } from "../constants/api";

export interface ReverseGeocodeResult {
  placeId: string;
  formattedAddress: string;
  city: string;
  state: string;
  country: string;
  location: {
    lat: number;
    lng: number;
  };
}

// Used to fetch place details from latitude/longitude
export async function fetchReverseGeocoding({
  latitude,
  longitude,
}: {
  latitude: number;
  longitude: number;
}): Promise<ReverseGeocodeResult | null> {
  const url = `${AWS_LOCATION_BASE_URL}/reverse-geocode?key=${encodeURIComponent(AWS_LOCATION_API_KEY)}`;

  const response = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      QueryPosition: [longitude, latitude], // Amazon uses [lng, lat] order
      Language: "en",
      MaxResults: 1,
      Filter: {
        IncludePlaceTypes: ["Locality"],
      },
    }),
  });

  if (!response.ok) {
    throw new Error(`Error: ${response.statusText}`);
  }

  const data = await response.json();
  const item: ReverseGeocodeResultItem | undefined = data.ResultItems?.[0];

  if (!item) return null;

  return {
    placeId: item.PlaceId ?? "",
    formattedAddress: item.Address?.Label ?? item.Title ?? "",
    city: item.Address?.Locality ?? "",
    state: item.Address?.Region?.Name ?? item.Address?.SubRegion?.Name ?? "",
    country: item.Address?.Country?.Name ?? "",
    location: {
      lat: item.Position?.[1] ?? latitude,
      lng: item.Position?.[0] ?? longitude,
    },
  };
}
